import { ActionIcon, Text, TextInput } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { useFormContext } from "react-hook-form";
import { useIsOnline } from "src/hooks";

import {
  StyledRemoveActionIcon,
  StyledYachtSetUpItem,
} from "../YachtSetUp.styled";

interface Props {
  id: string;
  remove: () => void;
  disabled?: boolean;
}

const BiofoulingItem = ({ id, remove, disabled }: Props) => {
  const { register } = useFormContext();
  const isOnline = useIsOnline();
  const isDisabled = !isOnline || disabled;
  return (
    <StyledYachtSetUpItem style={{ width: "100%" }}>
      <Text size="sm">Name:</Text>
      <TextInput
        style={{ flex: 1 }}
        {...register(`${id}.name`, { disabled: isDisabled })}
      />
      <Text size="sm">Description:</Text>
      <TextInput
        style={{ flex: 1 }}
        {...register(`${id}.desc`, { disabled: isDisabled })}
      />
      {disabled ? (
        <ActionIcon w="sm" style={{ cursor: "default" }} />
      ) : (
        <StyledRemoveActionIcon
          disabled={isDisabled}
          onClick={remove}
          variant="outline"
          size={"sm"}>
          <IconX />
        </StyledRemoveActionIcon>
      )}
    </StyledYachtSetUpItem>
  );
};

export default BiofoulingItem;
